import request from '@/utils/request'

/**
 * 根据公众号id获取所有消息回复
 */

export const getAllReplyDataById = async (data) => {
  return await request({
    url: 'yia/v1/reply/page',
    method: 'GET',
    params: data
  })
}

/**
 *  保存当前id公众号的消息回复
 */
export const saveReplyById = async (data) => {
  return await request({
    url: 'yia/v1/reply/save',
    method: 'POST',
    data: data
  })
}

/**
 * 删除回复消息
 */
export const delReplyById = async (id) => {
  return await request({
    url: `yia/v1/reply/${id}`,
    method: 'DELETE'
  })
}

/**
 * 获取图片素材或者图文素材
 * type=image图片素材，news图文素材
 */

export const getMaterial = async (path, type, currentPage) => {
  return await request({
    url: `yia/v1/wx/client/${path}/material?page=${currentPage}&type=${type}`,
    method: 'GET'
  })
}

/**
 * 获取图文自动回复列表
 */
export const getAllNewsReplyById = async (path, currentPage) => {
  return await request({
    url: `yia/v1/wx/client/${path}/publish?page=${currentPage}`,
    method: 'GET'
  })
}

/**
 *  获取单个回复消息
 */
export const getNewsReplyById = async (newsReplyId) => {
  return await request({
    url: `yia/v1/reply/${newsReplyId}`,
    method: 'GET'
  })
}

/**
 * 获取欢迎词回复消息
 */
export const getWelcomeReplyByAccountId = async (accountId) => {
  return await request({
    url: `yia/v1/reply/getWelcome/${accountId}`,
    method: 'GET'
  })
}
